import type { QuestionOption } from '@stepform';

export function toOptions(map: Record<string, string>): QuestionOption[] {
  return Object.entries(map).map(([value, label]) => ({ value, label }));
}

export const PLACEHOLDER_FIELD_OPTIONS: Record<
  string,
  QuestionOption[] | Record<string, QuestionOption[]>
> = {
  ReportingPeriod: [{ value: '2025-Q1', label: 'Jan - Mar 2025' }],
  WorkersOnSite: toOptions({
    '1': 'Workers were on-site during the reporting period',
    '0': 'No workers were on-site at any time during the reporting period',
  }),
  OperationType: toOptions({
    'underground-mine': 'Underground mine',
    'opencast-mine': 'Opencast mine',
    'alluvial-mine': 'Alluvial mine',
    quarry: 'Quarry',
    tunnel: 'Tunnel',
    'coal-exploration': 'Coal exploration',
  }),
  PrimaryMaterial: {
    'underground-mine': toOptions({ coal: 'Coal', gold: 'Gold', other: 'Other' }),
    'opencast-mine': toOptions({ coal: 'Coal', gold: 'Gold', other: 'Other' }),
    'alluvial-mine': toOptions({ gold: 'Gold', sand: 'Sand', other: 'Other' }),
    quarry: toOptions({
      aggregate: 'Aggregate',
      basalt: 'Basalt',
      clay: 'Clay',
      limestone: 'Limestone',
      other: 'Other',
    }),
  },
  ManagerCertOfCompetence: toOptions({
    'mine-manager': 'Mine Manager',
    'quarry-manager': 'Quarry Manager',
    'tunnel-manager': 'Tunnel Manager',
  }),
  SubmitterRole: {
    'underground-mine': toOptions({
      'mine-manager': 'Mine Manager',
      'site-senior-executive': 'Site Senior Executive',
      other: 'Other',
    }),
    quarry: toOptions({
      'quarry-manager': 'Quarry Manager',
      other: 'Other',
    }),
  },
  NotifiableEvents: toOptions({ '1': 'Yes', '0': 'No' }),
  Injuries: toOptions({ '1': 'Yes', '0': 'No' }),
  Fatalities: toOptions({ '1': 'Yes', '0': 'No' }),
};

export function resolveFieldOptions(
  fieldOptions?: Record<string, QuestionOption[] | Record<string, QuestionOption[]>>
): Record<string, QuestionOption[] | Record<string, QuestionOption[]>> {
  return {
    ...PLACEHOLDER_FIELD_OPTIONS,
    ...fieldOptions,
  };
}
